function main() {
  return(
  `
    <div class="main">
      <p class="main_text"></p>
      <input type="text" placeholder="You may answer here!" class="main_input"></input>
    </div>
  `
  )
}

export default main;